export default __webpack_public_path__ + "static/media/DOC.de734f04.svg";